export default class NotificationSettingTypes {
    static types = [
        {
            label : 'Email + In App',
            value : 'email_and_app'
        },
        {
            label : 'Email Only',
            value : 'email_only'
        },
        {
            label : 'App Only',
            value : 'app_only'
        }
    ]

    static label(value) {
        return NotificationSettingTypes.types.find(level => level.value === (value ?? 'email_and_app'))?.label;
    }
}